export default {
  colors: {
    // brand colors
    brand_yellow: '#FDC80A',
    brand_green: '#67B419',
    brand_blue: '#118BD6',

    // brand tints
    brand_tint_yellow: '#FEE384',
    brand_tint_green: '#B3D98C',
    brand_tint_blue: '#88C5EA',

    // background colors
    bg_gray_dark: '#D6D9DF',
    bg_gray: '#EDEFF5',
    bg_gray_light: '#F8F8F9',
    bg_white: '#FFFFFF',

    // text colors
    heading_light: '#FFFFFF',
    heading_dark: '#202020',
    text_light: '#FFFFFF',
    text_dark: '#515151',
    link: '#4DA8E1',
    link_hover: '#88C5EA',

    // semantic colors
    information: '#118BD6',
    information_bg: '#C3E2F5',
    negative: '#CF142B',
    negative_bg: '#F3C4CA',
    attention: '#FDC80A',
    attention_bg: '#FEE384',
    positive: '#67B419',
    positive_bg: '#D9ECC5',

    // common
    white: '#ffffff',
    gray_light: '#9a9aa4',
  },
};
